export const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

export const base64ToFile = (base64, filename, mimeType) => {
  return fetch(base64)
    .then((res) => res.arrayBuffer())
    .then((buffer) => new File([buffer], filename, { type: mimeType }));
};

export const getFileNameInfos = (file) => {
  const splittedName = file.name.split('.');
  const type = splittedName.pop();
  return {
    name: splittedName.join('.'),
    type,
  };
};

export const getImageSize = (url) => {
  const img = document.createElement('img');
  const promise = new Promise((resolve, reject) => {
    img.onload = () => {
      // Natural size is the actual image size regardless of rendering.
      // The 'normal' `width`/`height` are for the **rendered** size.
      const width = img.naturalWidth;
      const height = img.naturalHeight;

      // Resolve promise with the width and height
      resolve({ width, height });
    };

    // Reject promise on error
    img.onerror = reject;
  });

  // Setting the source makes it start downloading and eventually call `onload`
  img.src = url;

  return promise;
};
